import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
// import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import CloseIcon from '@mui/icons-material/Close';
// import SearchIcon from '@mui/icons-material/Search';
import { blue_pilu, white_pilu } from '../../../helpers/utils';
import { Button, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// const Search = styled('div')(({ theme }) => ({
// 	position: 'relative',
// 	borderRadius: theme.shape.borderRadius,
// 	backgroundColor: alpha(theme.palette.common.white, 0.15),
// 	'&:hover': {
// 		backgroundColor: alpha(theme.palette.common.white, 0.25),
// 	},
// 	marginLeft: 0,
// 	width: '100%',
// 	[theme.breakpoints.up('sm')]: {
// 		marginLeft: theme.spacing(1),
// 		width: 'auto',
// 	},
// }));

// const SearchIconWrapper = styled('div')(({ theme }) => ({
// 	padding: theme.spacing(0, 2),
// 	height: '100%',
// 	position: 'absolute',
// 	pointerEvents: 'none',
// 	display: 'flex',
// 	alignItems: 'center',
// 	justifyContent: 'center',
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
// 	color: 'inherit',
// 	'& .MuiInputBase-input': {
// 		padding: theme.spacing(1, 1, 1, 0),
// 		// vertical padding + font size from searchIcon
// 		paddingLeft: `calc(1em + ${theme.spacing(4)})`,
// 		transition: theme.transitions.create('width'),
// 		width: '100%',
// 		[theme.breakpoints.up('sm')]: {
// 			width: '12ch',
// 			'&:focus': {
// 				width: '20ch',
// 			},
// 		},
// 	},
// }));

const whiteButtonStyle = {
	backgroundColor: white_pilu,
	color: blue_pilu,
};

export const SearchAppBar = ({
	title,
	handleClose,
	numberOfBiases,
	counterBiasRow,
	setCounterBiasRow,
	logistics_is_done,
}) => {
	return (
		<AppBar position='static' style={{ backgroundColor: blue_pilu }}>
			<Toolbar>
				<IconButton
					edge='start'
					color='inherit'
					onClick={handleClose}
					aria-label='close'
				>
					<CloseIcon />
				</IconButton>
				<Typography
					variant='h6'
					noWrap
					component='div'
					sx={{
						flexGrow: 1,
						display: { xs: 'none', sm: 'block' },
						ml: 2,
					}}
				>
					{logistics_is_done && (
						<Tooltip
							title='Partida revisada por Logística'
							placement='bottom'
						>
							<CheckCircleIcon
								style={{
									margin: '0 10px 5px 0',
									color: 'white',
								}}
							/>
						</Tooltip>
					)}
					{title}
				</Typography>
				{/* <Search>
					<SearchIconWrapper>
						<SearchIcon />
					</SearchIconWrapper>
					<StyledInputBase
						placeholder='Buscar talla'
						inputProps={{ 'aria-label': 'search' }}
					/>
				</Search> */}
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						width: '360px',
						justifyContent: 'space-evenly',
					}}
				>
					<Button
						onClick={handleClose}
						style={whiteButtonStyle}
						variant='contained'
					>
						Salir
					</Button>
					{counterBiasRow > 0 && (
						<Button
							onClick={() => {
								setCounterBiasRow(counterBiasRow - 1);
							}}
							style={whiteButtonStyle}
							variant='contained'
						>
							Anterior
						</Button>
					)}
					{counterBiasRow < numberOfBiases - 1 && (
						<Button
							onClick={() => {
								setCounterBiasRow(counterBiasRow + 1);
							}}
							style={whiteButtonStyle}
							variant='contained'
						>
							Siguiente
						</Button>
					)}
				</div>
			</Toolbar>
		</AppBar>
	);
};
